
import React from 'react';
import SVGComponent from '../SVG/SVGComponent';
import { SVG_ICONS } from '../../constants';

/**
 * @module Modals/SuccessModal
 */

/**
 * @typedef {object} props
 * @property {object} user
 * @property {object} modalData
 * @property {string} modalData.heading
 * @property {string} modalData.modal
 * @property {string} modalData.message
 * @property {string} [modalData.additionalMessage]
 * @property {string} [modalData.email]
 * @property {Function} setOpenModal
 */

/**
 * @param {props} props
 * @returns {view}
 */
export default (props) => (
  <div className="modal modal--open">
    <div className="dialog p-0">
      <div className="dialog__info text-center">
        <SVGComponent
          className="dialog__info-icon"
          src={`${SVG_ICONS.homeIcons}#success`}
        />
        <h2>Success !</h2>
        <p>
          {props.modalData.message}
          {props.modalData.user
            && (
              <strong>
                <br />
                {props.modalData.user.username}
              </strong>
            )}
          <br />
          {props.modalData.additionalMessage || null}
          {props.modalData.email
            && (
              <strong>
                <br />
                {props.modalData.user.email}
              </strong>
            )}
        </p>
      </div>
      <div
        className="dialog__info-btn dialog__info-btn--success"
        onClick={props.setOpenModal.bind(this, { modal: '' })}
      >
        Continue
      </div>
    </div>
  </div>
);
